export const ALL = {
  ALL: '전체',
} as const;
